package apap.oneverandah

fun sayHello(to: String): String =
    "Hello, $to!"